/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

export class CenteredContainerDisplay extends React.Component {
  static propTypes = {
    height: PropTypes.number,
    yAdjustPercentage: PropTypes.number,
    content: PropTypes.any.isRequired,
    useFullWidth: PropTypes.bool,
    className: PropTypes.string
  }

  constructor(props) {
    super(props)

    this.state = {
      height: typeof props.height === 'number'
        ? props.height
        : null
    }

    this.outerDivRef = React.createRef()
  }

  componentDidMount() {
    // if screen height is used by default because height prop not provided,
    // adjust height according to top coordinate of this div
    if (!this.props.height) {
      let height = this.getAbsoluteHeight()
      this.setState({ height }, () => (
        // get top Y coordinate
        this.adjustHeight(this.outerDivRef.current.getBoundingClientRect().top)
      ))
    } else {
      this.adjustHeight(this.outerDivRef.current.getBoundingClientRect().top)
    }
  }

  // get full height of a html element (div) including border, padding and margin
  getAbsoluteHeight = () => {
    let element = this.outerDivRef.current

    let styles = window.getComputedStyle(element)
    let margin = parseFloat(styles['marginTop']) +
                 parseFloat(styles['marginBottom'])

    return Math.ceil(element.offsetHeight + margin)
  }

  adjustHeight = (top) => {
    let newHeight = this.state.height - top
    this.setState({ height: newHeight })
  }

  calculateYAdjustPercentageAsPixels = () => (
    this.state.height * (this.props.yAdjustPercentage / 100)
  )

  render() {
    return (
      <div
        ref={this.outerDivRef}
        className={`slds-align_absolute-center ${this.props.className ? this.props.className : ''}`}
        style={this.state.height ? { height: this.state.height } : {}}>
        <div
          className={this.props.useFullWidth ? 'slds-size_1-of-1' : ''}
          style={{ transform: `translateY(${this.calculateYAdjustPercentageAsPixels()}px)`}}>
          {this.props.content}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/centered-container-display/index.js